import {
  ACTION_LOGIN_BY_NICK__REQUEST,
  ACTION_LOGIN_BY_NICK__SUCCESS,
  ACTION_LOGIN_BY_NICK__FAIL,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_LOGIN_BY_NICK__REQUEST:
    case ACTION_LOGIN_BY_NICK__SUCCESS:
      return null;

    case ACTION_LOGIN_BY_NICK__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
